<template>
  <div>
    <div v-if="legacySubscriptions && selectedProduct" class="container" data-test-hook="upgrade-to-multi-home-modal">
      <b-row align-h="center" class="mb-0 pb-0 current-plan" no-gutters>
        <b-col class="text-center">
          <div align-h="around" class="row mb-3 ml-3 mr-3">
            <p class="text-center plan-details-header-notice mx-auto">
              {{ $t('xUpgradeToNewSubscriptionTitle') }}
            </p>
            <p class="text-center plan-details-header" data-test-hook="new-plan-with-upgrade-text">
              {{
                $t('xUpgradeToNewSubscriptionText', {
                  0: getCurrencyString(selectedProduct.cost),
                  1: closestNextBillingDate
                })
              }}
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="0" style="width:100%">
          <SubscriptionUpgradeYearlyMonthlyCard
            :subscription-product="annualProduct"
            :apparatuses-to-add="apparatusesOnNewPlan"
            :is-new-plan="true"
            @setSelectedProduct="setSelectedProduct"
          />
        </b-col>
      </b-row>
      <b-row no-gutters class="mt-3">
        <b-col cols="12">
          <b-button
            variant="warning"
            class="w-100 btn btn-primary"
            @click="immediateCancelLegacyAndProceedToPayment"
            data-test-hook="upgrade-to-multi-home-modal-button-continue"
            :disabled="isCancellingLegacyPlans"
          >
            {{ $t('xUpgradeNow') }}
            <b-spinner class="ml-2" v-if="isCancellingLegacyPlans" />
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-center">
          <p class="text-small legal-text">*{{ $t('xPushNotificationsAreAvailableWithInstallation') }}</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'
import SubscriptionUpgradeYearlyMonthlyCard from './Common/SubscriptionUpgradeYearlyMonthlyCard.vue'
import { isFuelMonitorV2 } from '../../../utils/apparatus'

export default {
  props: ['accountData', 'legacySubscriptions', 'selectedProduct', 'annualProduct', 'monthlyProduct', 'apparatusList'],
  emits: ['openPayment', 'setSelectedProduct'],
  components: {
    SubscriptionUpgradeYearlyMonthlyCard
  },
  data() {
    return {
      apparatusesOnNewPlan: [],
      isCancellingLegacyPlans: false
    }
  },
  methods: {
    setSelectedProduct(product) {
      this.$emit('setSelectedProduct', product)
    },
    async immediateCancelLegacyAndProceedToPayment() {
      if (this.accountData?.organizationId) {
        this.isCancellingLegacyPlans = true
        const immediateCancelBatch = []
        this.legacySubscriptions.forEach(legacySub => {
          immediateCancelBatch.push(
            this.$store.dispatch('cancelSubscriptionProductImmediately', {
              organizationId: this.accountData.organizationId,
              store: Constants.WebSubscriptionStore,
              productId: legacySub.productId,
              apparatusId: legacySub.apparatusId
            })
          )
        })

        Promise.all(immediateCancelBatch)
          .then(() => {
            this.$emit('openPayment')
          })
          .catch(() => {
            this.$store.dispatch('displayToast', {
              title: this.$t('xSomethingWentWrong'),
              message: this.$t('xPleaseTryAgain'),
              variant: 'danger'
            })
          })
          .finally(() => {
            this.isCancellingLegacyPlans = false
          })
      }
    }
  },
  mounted() {
    if (this.apparatusList) {
      // assume that, since there are active legacy subs, there are no new subs
      // therefore we can assume that ALL eligible (non-DM and non-v1) products should be subscribed to the new plan
      this.apparatusesOnNewPlan = this.apparatusList?.filter(app => {
        return (
          (app.type === Constants.HsbApparatusType ||
            (app.type === Constants.FuelTankApparatusType && isFuelMonitorV2(app))) &&
          !app.isDealerManaged
        )
      })
    }
  },
  computed: {
    closestNextBillingDate() {
      let closestDate
      if (this.legacySubscriptions?.length > 0) {
        this.legacySubscriptions.forEach(sub => {
          const renewDate = this.$moment(sub.nextBillingDate)

          if (sub.status === Constants.SubscriptionActive) {
            if (!closestDate) {
              closestDate = renewDate
            } else if (renewDate.isAfter(new Date()) && renewDate.isBefore(closestDate)) {
              closestDate = renewDate
            }
          }
        })
      }

      if (!closestDate) {
        closestDate = this.$moment(new Date())
      }

      return closestDate.format(this.$t('xShortDate'))
    }
  }
}
</script>
<style lang="scss">
.upgrade-desc {
  line-height: 1.4rem;
  margin-bottom: 0;
  font-size: 0.875rem;
}

.header {
  font-size: large;
  font-weight: 550;
  padding-left: 0;
}
</style>
